// Force the + / - behavior ONLY inside the cart drawer (Dawn)
// Prevents double-handlers (apps/theme scripts) from reversing the action.

(function () {
  function dispatchNative(el, type) {
    el.dispatchEvent(new Event(type, { bubbles: true }));
  }

  function onAction(e) {
    const drawer = document.getElementById("CartDrawer");
    if (!drawer || !drawer.contains(e.target)) return;

    const btn = e.target.closest('button.quantity__button');
    if (!btn) return;

    // Only handle real +/- buttons
    const isPlus = btn.getAttribute("name") === "plus";
    const isMinus = btn.getAttribute("name") === "minus";
    if (!isPlus && !isMinus) return;

    const qtyInput = btn.closest("quantity-input")?.querySelector('input.quantity__input[type="number"]');
    if (!qtyInput) return;

    // HARD STOP other scripts from hijacking this click
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    const step = parseInt(qtyInput.getAttribute("step") || "1", 10) || 1;
    const min  = parseInt(qtyInput.getAttribute("min") || "0", 10) || 0;
    const maxAttr = qtyInput.getAttribute("max");
    const max  = maxAttr !== null ? (parseInt(maxAttr, 10) || null) : null;

    let val = parseInt(qtyInput.value || "0", 10) || 0;
    val = isPlus ? (val + step) : (val - step);

    if (val < min) val = min;
    if (max !== null && val > max) val = max;

    qtyInput.value = String(val);

    // Trigger Dawn's cart update flow
    dispatchNative(qtyInput, "input");
    dispatchNative(qtyInput, "change");
  }

  // Capture phase to beat other listeners
  document.addEventListener("click", onAction, true);
})();